// modalService.js
const CURRENT_VERSION = process.env.VERSION;
const STORAGE_KEY = "STORED_VERSION";
const DIALOG_NAME_PREFIX = "DIALOG_";

const getStoredVersion = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
};

const setStoredVersion = () =>
  localStorage.setItem(STORAGE_KEY, JSON.stringify(CURRENT_VERSION));

const hasSeenUpdate = () => {
  const storedVersion = getStoredVersion();
  return storedVersion && storedVersion === CURRENT_VERSION;
};

const getDialogKey = (dialogName) => (`${DIALOG_NAME_PREFIX}${dialogName}`);

const hasSeenDialog = (dialogName) => {
  return localStorage.getItem(getDialogKey(dialogName)) === 'true';
};

const markDialogAsSeen = (dialogName) => {
  localStorage.setItem(getDialogKey(dialogName), 'true');
};

export { hasSeenUpdate, setStoredVersion, hasSeenDialog, markDialogAsSeen };
